export { default } from './useId';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useId/index.js
// module id = 231
// module chunks = 25